import { lazy } from 'react'

export const AddNewUserModalAsync = lazy(() =>
    import('./AddNewUserModal').then((component) => ({
        default: component.AddNewUserModal,
    }))
)
